// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__3ENkM","load8":"Spinner_load8__1FLaS"};